import apiClient from './apiClient';

export async function fetchScheduledTasks() {
  const { data } = await apiClient.get('/scheduler/tasks');
  return data.map((t) => ({ ...t, lastRunStatus: t.lastRunStatus?.toLowerCase() }));
}

export async function addScheduledTask(payload) {
  const { data } = await apiClient.post('/scheduler/tasks', payload);
  return { ...data, lastRunStatus: data.lastRunStatus?.toLowerCase() };
}

export async function setTaskActive(id, active) {
  const { data } = await apiClient.patch(`/scheduler/tasks/${id}`, { active });
  return { ...data, lastRunStatus: data.lastRunStatus?.toLowerCase() };
}
